import genderList from "../data/genderList";

export default {
    data() {
        return {
            data: {
                user_id: '',
                head_pic: '',
                nickname: '',
                sex: '',
                birthday: '',
                address: '',
                phone: '',
                signature: '',
            },
            optionProps: {              // 三级联动指定绑定属性
                value: 'title',
                label: 'title',
                children: 'child'
            },
            address_value: [],
            address_list: [],
            genderList,
        }
    },

    created() {
        this.getUserinfo();
        this.getAddress();
    },

    methods: {
        // 获取地址信息
        getAddress() {
            this.$post('api.php/Index/getCity').then(res => {
                if(res.status == 1) {
                    let arr = res.data || [];
                    this.formatData(arr)
                    this.address_list = this.formatData(arr);
                }
            })
        },

        handleChange(e) {
            this.data.address = e.join(',');
        },

        formatData(data) {
            for (let i = 0;i<data.length;i++) {
                if (data[i].items && data[i].items.length <= 0) {
                    data[i].items = undefined;
                }else {
                    data[i].items && this.formatData(data[i].items)
                }
            };
            return data;
        },

        // 上传头像
        uploadHttp(file) {
            console.log(file)
            this.$uploadOSS(file.file,0).then(res => {
                this.data.head_pic = res;
            })
        },

        // 获取用户信息
        getUserinfo() {
            this.$post('api.php/User/userInfo',{
                token: this.$getToken()
            }).then(res => {
                if(res.status === 1) {
                    let user = res.data || {};
                    this.data.head_pic = user.head_pic;
                    this.data.nickname = user.nick_name;
                    this.data.sex = user.sex === 0 ? '' : user.sex === 1 ? '男' : '女';
                    this.data.birthday = user.birthday;
                    this.data.address = user.address;
                    this.address_value = user.address.split(',') || [];
                    this.data.phone = user.mobile;
                    this.data.signature = user.signature;
                    localStorage.setItem('userinfo',this.$Encrypt(JSON.stringify(user)))
                }else if(res.status === -1) {
                    localStorage.removeItem('userinfo');
                }
            })
        },

        // 提交
        submitSave() {
            this.$post('api.php/Index/information',{
                user_id: this.$getUserinfo().id,
                head_pic: this.data.head_pic,
                nick_name: this.data.nickname,
                birthday: this.data.birthday,
                sex: this.data.sex === '男' ? 1 : this.data.sex === '女' ? 2 : this.data.sex,
                address: this.data.address,
                phone: this.data.phone,
                signature: this.data.signature
            }).then(res => {
                if(res.status === 1) {
                    this.$message.success(res.info);
                    localStorage.setItem('userinfo',this.$Encrypt(JSON.stringify(data)))
                }else {
                    this.$message.info(res.info);
                }

            })
        }
    }
}
